import React from 'react';
import PropTypes from 'prop-types';
import Select from '../Select';
import companyStatuses from '../../../constants/companyStatuses';


const CompanyStatusDropdown = ({ value, onChange }) => (
  <Select
    value={value}
    onChange={onChange}
    options={companyStatuses}
  />
);

CompanyStatusDropdown.propTypes = {
  value: Select.propTypes.value,
  onChange: PropTypes.func,
}

export default CompanyStatusDropdown;


// WEBPACK FOOTER //
// src/components/shared/CompanyStatusDropdown/index.jsx